import { render, staticRenderFns } from "./ExistingAssetImporter.vue?vue&type=template&id=18bb5054"
import script from "./ExistingAssetImporter.vue?vue&type=script&lang=js"
export * from "./ExistingAssetImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports